import {
    addProductUrl, captainReportingUrl,
    getStockUrl, getTGroupedProductUrl,
    getTopSelling, orderReportingUrl,
    singleProductUrl, updateProductStatusUrl,
    updateProductUrl,kotActivityReportingUrl,combinedReportingUrl,
    exportProductExcelUrl
} from "../api";

import {hideLoader, showLoader} from "../../../actions/loader";
import {notification} from "../../../components/Elements/appUtils";
import axios from "axios";
import {getToken} from "../../../request";

export const fetchProduct = async (valData) => {
    let config = {
        params: {...valData},
        ...await getToken()
    };
    const {data} = await axios.get(getStockUrl(), config);
    return data;
};
export const fetchTopSelling = async () => {
    const {data} = await axios.get(getTopSelling(), getToken());
    return {data};
};

export const addProductFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());
    const {data} = await axios.post(addProductUrl(), valData, getToken());
    dispatch(hideLoader());
    if (!data.error) {
        notification.success({message: data.message || "Success"});
    } else {
        notification.error({message: data.message || "Error"});
    }
    return data;
};

export const singleProductFxn = (id) => async (dispatch) => {
    dispatch(showLoader());

    let {data} = await axios.get(singleProductUrl(id), getToken());
    dispatch(hideLoader());
    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    }

    return data;
};
export const updateProductFxn = (valData) => async (dispatch) => {
    dispatch(showLoader());
    let {data} = await axios.post(updateProductUrl(), valData, getToken());
    dispatch(hideLoader());
    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    } else {
        notification.success({
            message: data.message || "Success",
        });
    }
    return data;
};

export const updateProductStatusFxn = (productId) => async (dispatch) => {
    dispatch(showLoader());
    let {data} = await axios.post(updateProductStatusUrl(productId), {}, getToken());
    dispatch(hideLoader());
    if (data.error) {
        notification.error({
            message: data.message || "Error",
        });
    } else {
        notification.success({
            message: data.message || "Success",
        });
    }
    return data;
};

export const GroupedProductList = async (valData) => {
    delete valData.results;
    delete valData.count;
    let config = {
        params: {...valData},
        ...await getToken()
    }
    console.log(config)
    const {data} = await axios.get(getTGroupedProductUrl(),config);
    return {data};
};

export const captainReportingFxn = async (valData) => {
    delete valData.results;
    delete valData.count;
    let config = {
        params: {...valData},
        ...await getToken()
    }
    console.log(config)
    const {data} = await axios.get(captainReportingUrl(),config);
    return {data};
};
export const orderReportingFxn = async (valData) => {
    delete valData.results;
    delete valData.count;
    let config = {
        params: {...valData},
        ...await getToken()
    }
    console.log(config)
    const {data} = await axios.get(orderReportingUrl(),config);
    return {data};
};
export const kotActivityReportingFxn = async (valData) => {
    delete valData.results;
    delete valData.count;
    let config = {
        params: { ...valData },
        ...await getToken()
    };
    const { data } = await axios.get(kotActivityReportingUrl(), config);
    return { data };
};
export const combinedReportingFxn = async (valData) => {
    // delete valData.results;
    // delete valData.count;
    let config = {
        params: { ...valData },
        ...await getToken()
    };
    const { data } = await axios.get(combinedReportingUrl(), config);
    return { data };
};

export const exportProductExcelFxn = (valData = {}) => async (dispatch) => {
    dispatch(showLoader());
    try {
        let params = { ...valData };
        delete params.results;
        delete params.count;
        delete params.page;

        let tokenConfig = await getToken();
        let config = {
            params,
            responseType: "blob",
            ...tokenConfig,
        };

        const response = await axios.get(exportProductExcelUrl(), config);
        const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        const dateStr = new Date().toISOString().slice(0, 10);
        link.setAttribute("download", `Products_${dateStr}.xlsx`);
        document.body.appendChild(link);
        link.click();
        if (link.parentNode) {
            link.parentNode.removeChild(link);
        }
        window.URL.revokeObjectURL(downloadUrl);

        notification.success({ message: "Product Excel downloaded successfully" });
    } catch (err) {
        console.error("Export product excel error:", err);
        notification.error({ message: "Failed to export Excel" });
    } finally {
        dispatch(hideLoader());
    }
};
